module.exports = __webpack_public_path__ + "img/矩形 22 拷贝.b04c2d8f.png";